import { useSiteConfig } from "@/hooks/useSiteConfig";
import { Reveal, ChapterTag } from "./primitives";

const FixedSupply = () => {
  const config = useSiteConfig();
  return (
    <section className="relative py-28 lg:py-40 border-t border-line overflow-hidden" data-testid="fixed-supply-section">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,rgba(214,181,106,0.06),transparent_60%)]" aria-hidden="true" />
      <div className="section-shell relative">
        <Reveal>
          <ChapterTag index={3} label="Fixed Supply" />
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="mt-8 font-display font-bold tracking-tight leading-[1.02] text-5xl sm:text-7xl lg:text-8xl" data-testid="fixed-supply-headline">
            <span className="text-gold">72 Trillion.</span>
            <br />
            <span className="text-mist">No More.</span>
          </h2>
        </Reveal>
        <Reveal delay={0.2}>
          <p className="mt-8 max-w-2xl text-base md:text-lg text-slate leading-relaxed" data-testid="fixed-supply-copy">
            The total supply of Jovino Coin is permanently fixed at{" "}
            <span className="font-mono text-gold">{config.token.maxSupply} JCV</span>. Once deployed, no additional JCV
            can be created. Fixed supply does not guarantee price appreciation — it guarantees predictability.
          </p>
        </Reveal>
        <div className="mt-16 grid gap-5 sm:grid-cols-3">
          {config.supplyPillars.map((p, i) => (
            <Reveal key={p.title} delay={0.15 + i * 0.1} testId={`supply-pillar-${i}`}>
              <div className="card-surface h-full rounded-xl p-8">
                <div className="font-mono text-xs tracking-[0.3em] text-gold">0{i + 1}</div>
                <h3 className="mt-4 font-display text-lg lg:text-xl font-semibold uppercase tracking-wide text-mist">{p.title}</h3>
                <p className="mt-3 text-sm text-slate leading-relaxed">{p.body}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FixedSupply;
